import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { TJsonQueryKeys } from '../../../packages/JsonQuery';
import { COMMON_PROPERTIES, COMMON_PROPERTIES_SUBURBAN } from 'shared/constants/commonProperties';

export const selectIsCommonFiltersSelected = createSelector(selectJsonQuery, jsonQuery => {
  const commonProperties = jsonQuery._type === 'suburbansale' ? COMMON_PROPERTIES_SUBURBAN : COMMON_PROPERTIES;

  return (Object.keys(jsonQuery) as TJsonQueryKeys[]).some(
    property => !commonProperties.includes(property) && jsonQuery[property] !== undefined,
  );
});
